module.exports = __webpack_public_path__ + "static/media/screen_tiles_2.3ce7baac.svg";